import { titleCase } from '@ls/js-utils';

const ScenarioType = {
    Contrib: 'Contrib',
    Rescaled: 'Rescaled',
};

export default ScenarioType;

export const scenarioTypeOptions = Object.values(ScenarioType).map(val => ({ label: titleCase(val), value: val }));

